import { Box, RtaProvider, SignIn } from '@rtaoutdoorlivingllc/rta-ui';
import { useKeystoneSession } from '../auth/use-keystone-session';

import type { ReactElement } from 'react';

/**
 * `RtaProvider` forks the Chakra context the app mounts above it. That is sound only because this
 * screen renders instead of the app, never inside it — the tool's own theme has nothing on screen
 * to clash with while it is up.
 */
export const LoginPage = (): ReactElement => {
	const session = useKeystoneSession();

	return (
		<RtaProvider>
			<Box h={'100vh'}>
				<SignIn session={session} appName={'RTA Blueprint'} blurb={'Sign in with your RTA account to open and edit designs.'} />
			</Box>
		</RtaProvider>
	);
};
